if (!window.__whatsNextSlick) {
  window.__whatsNextSlick = true;

  const prevIcon = '<svg aria-hidden="true" role="img" aria-labelledby="whats-nextprev" xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><title id="whats-nextprev">Whats Next Prev</title>  <path d="M0.295497 8.07112C-0.0950267 7.6806 -0.0950268 7.04743 0.295497 6.65691L6.65946 0.292945C7.04998 -0.0975789 7.68315 -0.097579 8.07367 0.292945C8.4642 0.68347 8.4642 1.31663 8.07367 1.70716L2.41682 7.36401L8.07367 13.0209C8.4642 13.4114 8.4642 14.0446 8.07367 14.4351C7.68315 14.8256 7.04998 14.8256 6.65946 14.4351L0.295497 8.07112ZM2.33594 7.36401L2.33594 8.36401L1.0026 8.36401L1.0026 7.36401L1.0026 6.36401L2.33594 6.36401L2.33594 7.36401Z" fill="currentColor"/></svg>';
  const nextIcon = '<svg aria-hidden="true" role="img" aria-labelledby="whats-nextnext" xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><title id="whats-nextnext">Whats Next Next</title><path d="M8.07169 8.07112C8.46221 7.6806 8.46221 7.04743 8.07169 6.65691L1.70773 0.292945C1.31721 -0.0975789 0.68404 -0.097579 0.293516 0.292945C-0.0970081 0.68347 -0.0970082 1.31663 0.293516 1.70716L5.95037 7.36401L0.293515 13.0209C-0.0970092 13.4114 -0.0970093 14.0446 0.293515 14.4351C0.684039 14.8256 1.3172 14.8256 1.70773 14.4351L8.07169 8.07112ZM6.03125 7.36401L6.03125 8.36401L7.36458 8.36401L7.36458 7.36401L7.36458 6.36401L6.03125 6.36401L6.03125 7.36401Z" fill="currentColor"/></svg>';

  const perView = () => {
    const width = window.innerWidth;
    if (width <= 749) return 1;
    if (width <= 1000) return 2;
    if (width <= 1200) return 3;
    return 4;
  };

  const realSlides = (track) => track.querySelectorAll('.whats-next__slide:not(.slick-cloned)');

  const alignTitles = (root) => {
    const titles = root.querySelectorAll('.whats-next__slide:not(.slick-cloned) [data-card-title]');
    const clones = root.querySelectorAll('.slick-cloned [data-card-title]');
    titles.forEach((node) => {
      node.style.minHeight = '';
    });
    const max = Array.from(titles).reduce((height, node) => Math.max(height, node.offsetHeight), 0);
    if (!max) return;
    titles.forEach((node) => {
      node.style.minHeight = `${max}px`;
    });
    clones.forEach((node) => {
      node.style.minHeight = `${max}px`;
    });
  };

  const hideClones = (track) => {
    track.querySelectorAll('.slick-cloned').forEach((slide) => {
      slide.setAttribute('aria-hidden', 'true');
      slide.inert = true;
    });
  };

  const mount = (section) => {
    const slider = section.querySelector('[data-whats-next]');
    const track = section.querySelector('[data-track]');
    if (!slider || !track || !window.jQuery || !window.jQuery.fn.slick) return;
    if (slider.dataset.bound === 'true') {
      slider._whatsNextSync?.();
      return;
    }

    slider.dataset.bound = 'true';
    const $track = window.jQuery(track);
    const viewport = section.querySelector('.whats-next__viewport');
    const note = slider.querySelector('[data-slider-note]');
    let currentShow = 0;

    const setCarousel = (active) => {
      if (active) {
        slider.setAttribute('role', 'region');
        slider.setAttribute('aria-roledescription', 'carousel');
        note?.removeAttribute('hidden');
      } else {
        slider.removeAttribute('role');
        slider.removeAttribute('aria-roledescription');
        note?.setAttribute('hidden', '');
      }
    };

    const destroy = () => {
      if ($track.hasClass('slick-initialized')) $track.slick('unslick');
      setCarousel(false);
    };

    const sync = () => {
      if (!track.isConnected) {
        window.removeEventListener('resize', onResize);
        return;
      }
      const show = perView();
      const count = realSlides(track).length;
      if (count <= show) {
        destroy();
        currentShow = show;
        alignTitles(section);
        return;
      }
      if ($track.hasClass('slick-initialized') && currentShow === show) {
        hideClones(track);
        alignTitles(section);
        return;
      }
      if ($track.hasClass('slick-initialized')) $track.slick('unslick');
      currentShow = show;
      setCarousel(true);
      $track.slick({
        infinite: true,
        draggable: true,
        slidesToShow: show,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: true,
        adaptiveHeight: false,
        accessibility: true,
        appendArrows: viewport,
        appendDots: slider,
        prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">${prevIcon}</button>`,
        nextArrow: `<button type="button" class="slick-next" aria-label="Next">${nextIcon}</button>`,
        customPaging: (_slick, index) => `<button type="button" aria-label="Go to card ${index + 1} of ${count}">${index + 1}</button>`,
      });
      hideClones(track);
      alignTitles(section);
    };

    const onResize = () => {
      window.clearTimeout(slider.resizeTimer);
      slider.resizeTimer = window.setTimeout(sync, 150);
    };

    $track.on('init reInit afterChange', () => hideClones(track));
    slider._whatsNextSync = sync;
    sync();
    window.addEventListener('resize', onResize);
    document.fonts?.ready.then(() => alignTitles(section));
  };

  const boot = () => {
    if (!window.jQuery?.fn?.slick) return;
    document.querySelectorAll('.section-whats-next').forEach(mount);
  };

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  if (document.readyState !== 'loading' && window.jQuery?.fn?.slick) boot();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('.section-whats-next');
    if (section) mount(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const track = event.target.querySelector?.('[data-track]');
    if (track && window.jQuery?.(track).hasClass('slick-initialized')) {
      window.jQuery(track).slick('unslick');
    }
  });
}
